<template>
    <div class="form-group_up">
        <label class="form-label" for="name-f">Пошук</label>
        <div class="input-group">
            <div class="input-group-prepend">
                <span class="input-group-text border-right-0">
                    <i class="fal fa-democrat"></i>
                </span>
            </div>
            
            <input
                type="text"
                v-model="search_txt"
                id="filter_search"
                class="form-control"
                placeholder="Пошук"
            />
            
            <div class="input-group-append srch">
                <button class="btn btn-primary shadow-0 waves-effect waves-themed" @click="send_search">
                    <i class="fal fa-search"></i>
                </button>
                
                <button type="button" class="btn btn-danger shadow-0 waves-effect waves-themed" @click="clear_form">
                    <span class="fal fa-times mr-1"></span>
                    Очистити
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "list_filter",
    
    props: {
        searchValue: {
            type: String,
            default: ''
        }
    },
    
    
    data() {
        return {
            search_txt: this.searchValue
        };
    },
    
    methods: {
        send_search() {
            this.$emit('search_called', this.search_txt);
        },
        
        clear_form() {
            this.search_txt = '';
            this.$emit('clean_filter');
        }
    }
};
</script>

<style scoped>
</style>
